import { TableRow } from "@tiptap/extension-table-row";

export const CustomTableRow = TableRow.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-id"),
        renderHTML: (attributes) => {
          if (!attributes.id) return {};
          return { "data-id": attributes.id };
        },
      },
      editableBy: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute("data-editable-by");
          if (!value) return null;
          try {
            return JSON.parse(value);
          } catch {
            return value
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }
        },
        renderHTML: (attributes) => {
          if (!attributes.editableBy) return {};
          const value = Array.isArray(attributes.editableBy)
            ? JSON.stringify(attributes.editableBy)
            : attributes.editableBy;
          return { "data-editable-by": value };
        },
      },
      adminBy: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute("data-admin-by");
          if (!value) return null;
          try {
            return JSON.parse(value);
          } catch {
            return value
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }
        },
        renderHTML: (attributes) => {
          if (!attributes.adminBy) return {};
          const value = Array.isArray(attributes.adminBy)
            ? JSON.stringify(attributes.adminBy)
            : attributes.adminBy;
          return { "data-admin-by": value };
        },
      },
      segmentType: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-segment-type"),
        renderHTML: (attributes) => {
          if (!attributes.segmentType) return {};
          return { "data-segment-type": attributes.segmentType };
        },
      },
      segmentName: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-segment-name"),
        renderHTML: (attributes) => {
          if (!attributes.segmentName) return {};
          return { "data-segment-name": attributes.segmentName };
        },
      },
      fieldId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-field-id"),
        renderHTML: (attributes) => {
          if (!attributes.fieldId) return {};
          return { "data-field-id": attributes.fieldId };
        },
      },
      headingType: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-heading-type"),
        renderHTML: (attributes) => {
          if (!attributes.headingType) return {};
          return { "data-heading-type": attributes.headingType };
        },
      },
      codifyStatus: {
        default: "idle",
        parseHTML: (element) =>
          element.getAttribute("data-codify-status") || "idle",
        renderHTML: (attributes) => {
          const status = attributes.codifyStatus || "idle";
          return {
            "data-codify-status": status,
            class: `codify-status-${status}`,
          };
        },
      },
    };
  },
});
